var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#3A3A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.018 51.5C54.33 51.5 50.518 47.686 50.518 42C50.518 36.314 54.33 32.5 60.018 32.5C65.706 32.5 69.518 36.314 69.518 42C69.518 47.686 65.706 51.5 60.018 51.5ZM60.018 37.5C56.484 37.5 53.518 39.466 53.518 42C53.518 44.034 56.484 48.5 60.018 48.5C63.552 48.5 66.518 44.034 66.518 42C66.518 39.466 63.55 37.5 60.018 37.5ZM65.994 73.5H54.006C49.166 73.5 46.5 70.85 46.5 66.038C46.5 60.716 49.512 54.5 56 54.5H64C70.488 54.5 73.5 60.714 73.5 66.038C73.5 70.85 70.834 73.5 65.994 73.5ZM56 57.5C50.614 57.5 47.5 64.034 47.5 66.038C47.5 69.166 48.848 70.5 54.006 70.5H65.994C71.152 70.5 72.5 69.166 72.5 66.038C72.5 64.036 69.386 57.5 64 57.5H56Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.1fd1f8d60a91f55e8857c451c4775c21.svg";
export { ForwardRef as ReactComponent };